import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Stack,
  Chip,
  Tooltip,
} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineSharpIcon from '@mui/icons-material/RemoveCircleOutlineSharp';

import { ImageBaseURL } from '../../utilities/api/axios';
import nodatafound from '../../utilities/dummy_assets/nodatafound.jpg';

const getImage = image =>
  image
    ? image.startsWith('http')
      ? image
      : `${ImageBaseURL}${image}`
    : nodatafound;

const renderers = {
  text: value => <Typography>{value || '-'}</Typography>,

  chip: value => <Chip label={value || '-'} size="small" />,

  tooltip: value => (
    <Tooltip title={value || '-'} arrow placement="top">
      <Typography
        fontSize={13}
        color="#8C8C8C"
        sx={{
          maxWidth: '70%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
        }}
      >
        {value || '-'}
      </Typography>
    </Tooltip>
  ),
};

const CommonInventoryCard = ({
  row,
  fields,
  onEdit,
  onDelete,
  onAddStock,
  onRemoveStock,
}) => {
  const imageUrl = getImage(row?.image);

  const getValue = field =>
    typeof field.value === 'function' ? field.value(row) : row[field.value];

  return (
    <Box
      sx={{
        border: '1px solid #E6E6E6',
        borderRadius: '12px',
        p: 2,
        background: '#fff',
        mb: 2,
      }}
    >
      {/* Header */}
      {/* Header */}
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          component="img"
          src={imageUrl}
          alt={row.name}
          sx={{
            width: 60,
            height: 60,
            border: '1px solid #E6E6E6',
            borderRadius: '12px',
            objectFit: 'contain',
          }}
          onError={e => {
            e.currentTarget.src = nodatafound;
            e.currentTarget.onerror = null;
          }}
        />

        {/* Title Section */}
        <Box flex={1} minWidth={0}>
          <Tooltip title={row.name || '-'} arrow>
            <Typography
              fontWeight={600}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
            >
              {row.name || '-'}
            </Typography>
          </Tooltip>

          <Typography
            fontSize={13}
            color="#8C8C8C"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textAlign: 'left',
            }}
          >
            {row.upc || 'No Subtext'}
          </Typography>
        </Box>

        {/* Actions */}
        <Stack direction="row">
          {onEdit && (
            <IconButton onClick={() => onEdit(row)}>
              <EditIcon fontSize="small" />
            </IconButton>
          )}

          {onDelete && (
            <IconButton onClick={() => onDelete(row)}>
              <DeleteOutlineSharpIcon
                fontSize="small"
                sx={{ color: '#C90505' }}
              />
            </IconButton>
          )}
        </Stack>
      </Stack>

      {/* Body */}
      <Stack spacing={1.2} mt={2}>
        {fields.map(field => {
          if (field.type === 'stockActions') {
            return (
              <Stack
                key={field.label}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontSize={13}>{field.label}</Typography>

                <Stack direction="row">
                  <IconButton onClick={() => onAddStock(row)}>
                    <AddCircleOutlineOutlinedIcon sx={{ color: 'green' }} />
                  </IconButton>

                  <IconButton onClick={() => onRemoveStock(row)}>
                    <RemoveCircleOutlineSharpIcon sx={{ color: '#C90505' }} />
                  </IconButton>
                </Stack>
              </Stack>
            );
          }

          const value = getValue(field);
          const renderer = renderers[field.type || 'text'];

          return (
            <Stack
              key={field.label}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography fontSize={13}>{field.label}</Typography>

              {renderer(value)}
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
};

export default CommonInventoryCard;
